import { render, staticRenderFns } from "./appNotificationManageAdd.vue?vue&type=template&id=0394c91c&scoped=true"
import script from "./appNotificationManageAdd.vue?vue&type=script&lang=js"
export * from "./appNotificationManageAdd.vue?vue&type=script&lang=js"
import style0 from "./appNotificationManageAdd.vue?vue&type=style&index=0&id=0394c91c&prod&lang=css"
import style1 from "./appNotificationManageAdd.vue?vue&type=style&index=1&id=0394c91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0394c91c",
  null
  
)

export default component.exports